import { InputAdornment, TextField, Typography } from '@mui/material'
import s from './HeuristicWithButton.module.css'
import { MouseEventHandler } from 'react'

import { ReactComponent as BookIcon } from '../../../assets/book.svg'
import { ReactComponent as StartIcon } from '../../../assets/star.svg'
import { ReactComponent as PlusIcon } from '../../../assets/plus.svg'
import { ReactComponent as CloseIcon } from '../../../assets/close.svg'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

interface HeuristicWithButtonProps {
  active?: boolean
  name: string
  nameNegative?: string
  favorite?: boolean
  onButtonClick?: MouseEventHandler<HTMLDivElement>
  onTextClick: MouseEventHandler<HTMLDivElement>
  mode?: 'add' | 'remove'
  negative?: boolean
  disabled?: boolean
  buttonHidden?: boolean
  withoutButton?: boolean
  criticality?: string
}

export const HeuristicWithButton = ({
  active = false,
  mode,
  name,
  onButtonClick,
  onTextClick,
  disabled = false,
  buttonHidden = false,
  favorite = false,
  negative,
  nameNegative,
  withoutButton = false,
  criticality,
}: HeuristicWithButtonProps) => {
  const negativeName = nameNegative || name
  const heuristicName = negative ? negativeName : name
  const { t } = useTranslation()

  return (
    <div
      className={classNames(s.wrapper, {
        [s.activeHeuristic]: active,
      })}
    >
      {mode === 'remove' ? (
        <TextField
          label={t('heuristic')}
          multiline
          value={heuristicName}
          onChange={() => null}
          fullWidth
          size="small"
          disabled
          InputLabelProps={{
            className: s.activeLabel,
          }}
          helperText={criticality}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <div
                  onClick={disabled ? undefined : onButtonClick}
                  className={s.closeIconWrapper}
                >
                  <CloseIcon />
                </div>
              </InputAdornment>
            ),
            className: classNames(s.text, s.activeColor),
            classes: {
              adornedEnd: s.activeColor,
              disabled: s.activeColor,
            },
          }}
        />
      ) : (
        <>
          <div
            className={classNames(s.textWrapper, {
              [s.disabled]: disabled || buttonHidden || withoutButton,
            })}
            onClick={onButtonClick}
          >
            <Typography className={s.text}>{heuristicName}</Typography>
            {favorite && (
              <StartIcon className={classNames(s.icon, s.starIcon)} />
            )}
            <PlusIcon className={classNames(s.icon, s.plusIcon)} />
          </div>
          <div className={s.detailsIconWrapper} onClick={onTextClick}>
            <BookIcon />
          </div>
        </>
      )}
    </div>
  )
}
